var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowToRightBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.606.557-1.01.966L16.68 4.74H.925v1.405h15.729L13.596 9.34l1.01.967 4.683-4.875L14.606.557Z",
  fill: "#111"
})));
export default SvgArrowToRightBlack;